import Skeleton from '@mui/material/Skeleton';

export const LandingLoader = () => (
  <div className='space-y-10 xl:space-y-24'>
    {[1, 2, 3, 4, 5].map((index) => (
      <div
        key={`loader-${index}`}
        className='flex items-center rounded-[10px] px-10 py-12 xl:py-9 min-h-[44px] xl:min-h-[52.79px]'
        style={{
          backgroundColor: '#F5F6FA',
        }}
      >
        <div className='w-[24px] h-[24px] xl:w-[30px] xl:h-[30px] flex-shrink-0'>
          <Skeleton animation='wave' variant='circular' width='100%' height='100%' style={{ backgroundColor: '#DFDFDF' }} />
        </div>
        <div className='flex-1 flex items-center ml-4'>
          <Skeleton animation='wave' height={14} width='20%' style={{ backgroundColor: '#DFDFDF', borderRadius: '4px', marginLeft: '20px' }} />
          <Skeleton animation='wave' variant='circular' height={15} width={15} style={{ backgroundColor: '#DFDFDF', borderRadius: '50%', marginLeft: '5px' }} />
        </div>
      </div>
    ))}
  </div>
);
